import findValuesRecursive from '../../../App/Helpers/findValuesRecursive'

export default function getTypes(result: any): string[] {
    let types: string[] = []
    for (const person of result.persons) {
        types = [...types, ...Object.keys(person)]
        if (person.absence_minutes) {
            types = [...types, ...findValuesRecursive(person.absence_minutes, 'type')]
        }
    }

    types = [...new Set(types)].filter((type) => type !== 'id' && type !== 'name' && type !== 'absence_minutes');
    types.sort(
        (typeA, typeB) => {
            if (typeA === 'working_minutes') {
                return -1
            }

            if (typeA === 'overtime_minutes' && typeB !== 'working_minutes') {
                return -1
            }

            return 0
        }
    )

    return types
}
